import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { UniversalSearchModel } from '../../../../core/models/universal-search.model';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { CommonUtilService } from '../../../../shared/services/CommonUtil.service';
import { SavedSearches } from '../../../../shared/services/saved-searches.service';
import { ContactsService } from '../../../contacts/services/contacts.service';
import { AccountAttributesEnum } from 'src/app/shared/enums/account-attributes.enum';
import { RequestBodyService } from 'src/app/shared/services';

@Component({
    selector: 'app-field-view',
    templateUrl: './field-view.component.html',
    styleUrls: ['./field-view.component.scss'],
    standalone: false
})
export class FieldViewComponent implements OnInit {
    @Input() fieldViewDetail: any;
    @Input() data: any;
    @Input() listDetail: any;
    @Output() contactClick: EventEmitter<any> = new EventEmitter<any>();
    readonly accountAttributesEnum: typeof AccountAttributesEnum = AccountAttributesEnum;
    contactColumnList;
    result: any;
    constructor(private auth: AuthenticationService, private commonUtilService: CommonUtilService, private contactsService: ContactsService, private savedSearchService: SavedSearches, private readonly requestBodyService: RequestBodyService) { }

    ngOnInit(): void {
        this.createContactColumnList();
        this.contactColumnList.forEach(column => {
            if (this.data[column.humanVerfied]) {
                if (column.humanVerfied == "append_match_ids_verified") {
                    column.humanVerfied = this.data[column.humanVerfied].length;
                } else {
                    column.humanVerfied = this.data[column.humanVerfied];
                }
            } else {
                column.humanVerfied = '0';
            }
            if (this.data[column.machineVerified]) {
                if (column.machineVerified == "append_match_ids_pending_verification") {
                    column.machineVerified = this.data[column.machineVerified].length;
                } else {
                    column.machineVerified = this.data[column.machineVerified];
                }
            } else {
                column.machineVerified = '0';
            }
            if (this.data[column.available_humanVerified]) {
                column.available_humanVerified = this.data[column.available_humanVerified];
            } else {
                column.available_humanVerified = '0';
            }
            if (this.data[column.available_machineVerified]) {
                column.available_machineVerified = this.data[column.available_machineVerified];
            } else {
                column.available_machineVerified = '0';
            }
        });
    }

    onViewContact(item, type) {
        let searchmodel = cloneDeep(UniversalSearchModel);
        this.requestBodyService.changeContactBodyData(undefined);
        this.requestBodyService.changeCompanyBodyData(undefined);
        this.requestBodyService.clearSearchSidebar.next(true);
        this.contactsService.contactLoadedFlag.next(true);
        this.savedSearchService.welComeLoadedFlag.next(true);

        const selectedLink = this.contactColumnList.filter(f => f.labelName === item.labelName)[0];

        if (type === 'machine') {
            searchmodel['match_ids'] = this.data[selectedLink.machineVerfiedMatchIds];
        } else if (type === 'human') {
            searchmodel['match_ids'] = this.data[selectedLink.verfiedMatchIds];
        } else if (type === 'available_human') {
            searchmodel['match_ids'] = this.data[selectedLink.available_verfiedMatchIds];
        } else {
            searchmodel['match_ids'] = this.data[selectedLink.available_machineVerfiedMatchIds];
        }
        if (selectedLink.required) {
            searchmodel.required_fields[selectedLink.required] = true;
        }
        searchmodel['contact_lists'] = [this.listDetail.id];
        searchmodel.is_international = null;
        searchmodel.location_country_codes = [];
        if (type === 'human') {
            searchmodel.tiers = this.auth.getHumanVerifiedTiers().toString();
        } else {
            searchmodel.tiers = this.auth.getPendingTiers().toString();
        }
        if(type === 'machine' || type === 'availble_machine') {
            searchmodel['accuracy_tier_contact'] = 'MV';
        }
        this.commonUtilService.requestBodyUniversalSubscription(searchmodel);
        this.contactClick.emit();
    }

    createContactColumnList() {
        this.contactColumnList= [
            {
                labelName: 'Any Phone',
                available_humanVerified: 'available_any_phone_count_verified',
                available_machineVerified: 'available_any_phone_count_all',
                humanVerfied: 'append_any_phone_count_verified',
                machineVerified: 'append_any_phone_count_all',
                machineVerfiedMatchIds: 'append_any_phone_match_ids_all',
                verfiedMatchIds: 'append_any_phone_match_ids_verified',
                available_machineVerfiedMatchIds: 'available_any_phone_match_ids_all',
                available_verfiedMatchIds: 'available_any_phone_match_ids_verified',
                required: 'phone'
            },
            {
                labelName: 'Any Direct Phone',
                available_humanVerified: 'available_any_direct_phone_count_verified',
                available_machineVerified: 'available_any_direct_phone_count_all',
                humanVerfied: 'append_any_direct_phone_count_verified',
                machineVerified: 'append_any_direct_phone_count_all',
                machineVerfiedMatchIds: 'append_any_direct_phone_match_ids_all',
                verfiedMatchIds: 'append_any_direct_phone_match_ids_verified',
                available_machineVerfiedMatchIds: 'available_any_direct_phone_match_ids_all',
                available_verfiedMatchIds: 'available_any_direct_phone_match_ids_verified',
                required: 'direct_phone'
            },
            {
                labelName: 'Any Mobile Phone',
                available_humanVerified: 'available_any_mobile_count_verified',
                available_machineVerified: 'available_any_mobile_count_all',
                humanVerfied: 'append_any_mobile_count_verified',
                machineVerified: 'append_any_mobile_count_all',
                machineVerfiedMatchIds: 'append_any_mobile_match_ids_all',
                verfiedMatchIds: 'append_any_mobile_match_ids_verified',
                available_machineVerfiedMatchIds: 'available_any_mobile_match_ids_all',
                available_verfiedMatchIds: 'available_any_mobile_match_ids_verified',
                required: 'any_mobile'
            },
            {
                labelName: 'Linkedin URL',
                available_humanVerified: 'available_linkedin_url_count_verified',
                available_machineVerified: 'available_linkedin_url_count_all',
                humanVerfied: 'append_linkedin_url_count_verified',
                machineVerified: 'append_linkedin_url_count_all',
                machineVerfiedMatchIds: 'append_linkedin_url_match_ids_all',
                verfiedMatchIds: 'append_linkedin_url_match_ids_verified',
                available_machineVerfiedMatchIds: 'available_linkedin_url_match_ids_all',
                available_verfiedMatchIds: 'available_linkedin_url_match_ids_verified',
                required: 'linkedin_url'
            },
            {
                labelName: 'Personal Email',
                available_humanVerified: 'available_personal_email_count_verified',
                available_machineVerified: 'available_personal_email_count_all',
                humanVerfied: 'append_personal_email_count_verified',
                machineVerified: 'append_personal_email_count_all',
                machineVerfiedMatchIds: 'append_personal_email_match_ids_all',
                verfiedMatchIds: 'append_personal_email_match_ids_verified',
                available_machineVerfiedMatchIds: 'available_personal_email_match_ids_all',
                available_verfiedMatchIds: 'available_personal_email_match_ids_verified',
                required: 'personal_email'
            },
            {
                labelName: 'Title',
                available_humanVerified: 'available_title_count_verified',
                available_machineVerified: 'available_title_count_all',
                humanVerfied: 'append_title_count_verified',
                machineVerified: 'append_title_count_all',
                machineVerfiedMatchIds: 'append_title_match_ids_all',
                verfiedMatchIds: 'append_title_match_ids_verified',
                available_machineVerfiedMatchIds: 'available_title_match_ids_all',
                available_verfiedMatchIds: 'available_title_match_ids_verified',
                required: 'job_title'
            }
        ];
    }

}
